import { render, staticRenderFns } from "./Nota.vue?vue&type=template&id=6056d88b&scoped=true"
import script from "./Nota.vue?vue&type=script&lang=js"
export * from "./Nota.vue?vue&type=script&lang=js"
import style0 from "./Nota.vue?vue&type=style&index=0&id=6056d88b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6056d88b",
  null
  
)

export default component.exports